import React from 'react';
import { Link } from 'react-router-dom';
import { Droplets } from 'lucide-react';
import { BRAND } from '@/lib/site';

export default function Footer() {
  return (
    <footer className="bg-navy-deep text-white/80">
      <div className="container-page grid gap-8 py-10 md:grid-cols-[1.4fr_1fr_1fr] md:items-start">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-water text-navy-deep">
              <Droplets className="h-5 w-5" strokeWidth={2.4} />
            </span>
            <span className="font-display text-lg font-extrabold text-white">{BRAND}</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
            Water damage help for homeowners in Coquitlam, Port Coquitlam and Port Moody.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/services" className="text-white/70 hover:text-water">Services</Link></li>
            <li><Link to="/areas" className="text-white/70 hover:text-water">Areas We Serve</Link></li>
            <li><Link to="/coquitlam" className="text-white/70 hover:text-water">Water Damage Coquitlam</Link></li>
            <li><Link to="/port-coquitlam" className="text-white/70 hover:text-water">Water Damage Port Coquitlam</Link></li>
            <li><Link to="/port-moody" className="text-white/70 hover:text-water">Water Damage Port Moody</Link></li>
            <li><Link to="/resources" className="text-white/70 hover:text-water">Resources</Link></li>
            <li><Link to="/contact" className="text-white/70 hover:text-water">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Information</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/about" className="text-white/70 hover:text-water">About</Link></li>
            <li><Link to="/privacy" className="text-white/70 hover:text-water">Privacy Policy</Link></li>
            <li><Link to="/faq" className="text-white/70 hover:text-water">FAQ</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-5 text-xs text-white/50 md:flex-row">
          <div className="flex items-center gap-3">
            <p>© {new Date().getFullYear()} {BRAND}. All rights reserved.</p>
            <span className="text-white/20">·</span>
            <Link
              to="/partner"
              className="text-[10px] text-white/30 transition hover:text-white/55"
            >
              Partner With Us
            </Link>
          </div>
          <p>Connection service only. Independent restoration providers perform the work.</p>
        </div>
      </div>
    </footer>
  );
}
